export default {
      id: "notes-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#notes-icon-usage",
      toString: function () {
        return this.url;
      }
    }